import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: number;
  title: string;
  titleEn: string;
  category: string;
  categoryName: string;
  year: number;
  rating: number;
  description: string;
  image: string;
}

export default function MovieCard({ id, title, titleEn, category, categoryName, year, rating, description, image }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={image}
          alt={title}
          title={`${title} - ${categoryName}推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
            {rating}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
          <span className="text-xs text-background-50/80">{year}</span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-base font-bold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-0.5">{titleEn}</p>
        <div className="flex items-center gap-2 mt-2">
          <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700">
            {categoryName}
          </span>
        </div>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">{description}</p>
      </div>
    </Link>
  );
}